export default {
  brandColor1: '#000',
  complimentaryColor1: '#fff',
  brandColor2: '#000',
  complimentaryColor2: '#fff',
};
